module.exports = __webpack_public_path__ + "static/reel-desk-68964aa9403770ade7f4f5c42adea51b.jpg";